import {PTGC_SELECT_ACTION} from './../../constants';

const selectAction = (selectedAction) => ({
    type: PTGC_SELECT_ACTION,
    selectedAction
});

export default selectAction;